class Quiz extends HTMLElement {
    constructor() { 
        super();
    }

    connectedCallback() {

        this.initialize();
        this.init();
    }

    initialize() {
        this.dataset.initialized = "true";

        this.fallbackProducts = [
            {
                id: "milk-dream",
                name: "Body Splash Milk Dream",
                label: "Milk Dream",
                profile: "Doce cremoso, caramelo, mel, chocolate branco, leite açucarado, baunilha e musk branco.",
                tags: ["doce", "cremoso", "aconchegante", "baunilha", "gourmand", "delicado"],
                tone1: "#f7ead7",
                tone2: "#e8cda8",
                bottle1: "#f5e9df",
                bottle2: "#d6a266"
            },
            {
                id: "coconut-skin",
                name: "Body Splash Coconut Skin",
                label: "Coconut Skin",
                profile: "Coco, areia morna, tuberosa, ylang-ylang, notas solares, âmbar e baunilha cremosa.",
                tags: ["tropical", "solar", "praia", "coco", "floral", "leve", "aconchegante"],
                tone1: "#f4dfc0",
                tone2: "#d8a15d",
                bottle1: "#f7e8cd",
                bottle2: "#b98143"
            },
            {
                id: "pistachio-paradise",
                name: "Body Splash Pistachio Paradise",
                label: "Pistachio",
                profile: "Pistache, amêndoas torradas, jasmim, heliotrópio, sândalo, baunilha e caramelo salgado.",
                tags: ["doce", "gourmand", "solar", "pistache", "floral", "quente", "baunilha"],
                tone1: "#e7dfc0",
                tone2: "#b9bf7b",
                bottle1: "#f6e5c7",
                bottle2: "#b98b45"
            },
            {
                id: "caramel-glow",
                name: "Body Splash Caramel Glow",
                label: "Caramel Glow",
                profile: "Baunilha caramelizada, sal marinho, macadâmia torrada, chocolate branco, fava tonka e flor de coco.",
                tags: ["doce", "gourmand", "cremoso", "quente", "sofisticado", "celebracao", "baunilha"],
                tone1: "#f0d2a4",
                tone2: "#c88c4f",
                bottle1: "#f3d9b4",
                bottle2: "#9e6a39"
            },
            {
                id: "vanilla-waves",
                name: "Body Splash Vanilla Waves",
                label: "Vanilla Waves",
                profile: "Amêndoas caramelizadas, castanha, flor de baunilha, jasmim, caramelo salgado e notas solares.",
                tags: ["doce", "baunilha", "solar", "quente", "aconchegante", "personalidade", "floral"],
                tone1: "#ead7c0",
                tone2: "#d7b085",
                bottle1: "#f0d4bc",
                bottle2: "#b87d51"
            },
            {
                id: "mermaid-kiss",
                name: "Body Splash Mermaid Kiss",
                label: "Mermaid Kiss",
                profile: "Melão, calone, melancia, flor de muguet, almíscar, âmbar e caramelo.",
                tags: ["fresco", "frutado", "aquatico", "sensual", "jovem", "leve", "verao"],
                tone1: "#bfe5e5",
                tone2: "#5bbfc3",
                bottle1: "#d7fbfa",
                bottle2: "#469aa5"
            },
            {
                id: "sex-on-the-beach",
                name: "Body Splash Sex on The Beach",
                label: "Sex Beach",
                profile: "Laranja, maçã vermelha, néctar de maracujá e rosas vermelhas, com energia tropical e sensual.",
                tags: ["frutado", "tropical", "sensual", "jovem", "energetico", "floral", "festa"],
                tone1: "#ffd1b9",
                tone2: "#ff7d57",
                bottle1: "#ffe0a8",
                bottle2: "#dc4d4c"
            },
            {
                id: "goxxtosa",
                name: "Body Splash Goxxtosa",
                label: "Goxxtosa",
                profile: "Frutas cítricas tropicais, muguet, rosas, musk e sândalo. Jovem, sensual e livre.",
                tags: ["frutado", "floral", "tropical", "sensual", "jovem", "fresco", "livre"],
                tone1: "#f7b6c9",
                tone2: "#d95c89",
                bottle1: "#f5d2dc",
                bottle2: "#9d5572"
            },
            {
                id: "summer-vibes",
                name: "Body Splash Summer Vibes",
                label: "Summer Vibes",
                profile: "Leite de coco, tuberosa, ylang-ylang, baunilha e âmbar. Brisa de verão e pele ao sol.",
                tags: ["tropical", "solar", "coco", "praia", "floral", "sensual", "verao"],
                tone1: "#f3d4a7",
                tone2: "#e0a25b",
                bottle1: "#fff0cf",
                bottle2: "#b67f45"
            }
        ];

        this.questionTitle = this.querySelector("[data-question-title]");
        this.questionSubtitle = this.querySelector("[data-question-subtitle]");
        this.optionsEl = this.querySelector("[data-options]");
        this.prevBtn = this.querySelector("[data-prev]");
        this.nextBtn = this.querySelector("[data-next]");
        this.stepLabel = this.querySelector("[data-step-label]");
        this.progressText = this.querySelector("[data-progress-text]");
        this.progressPercent = this.querySelector("[data-progress-percent]");
        this.progressBar = this.querySelector("[data-progress-bar]");
        this.quizArea = this.querySelector("[data-quiz-area]");
        this.resultArea = this.querySelector("[data-result-area]");
        this.resultGrid = this.querySelector("[data-result-grid]");
        this.restartBtn = this.querySelector("[data-restart]");

        

        this.questions = [
            {
                title: "Qual vibe você quer sentir hoje?",
                subtitle: "Escolha a sensação que mais combina com seu momento.",
                options: [
                    { label: "Doce e irresistível 🍬", desc: "Quero um cheirinho gourmand que abraça.", tags: ["doce", "gourmand", "cremoso", "aconchegante"] },
                    { label: "Solar e praiana ☀️", desc: "Quero aquele clima de pele quente no verão.", tags: ["solar", "praia", "coco", "verao"] },
                    { label: "Fresca e divertida 👯‍♂️", desc: "Quero leveza, frutas e sensação refrescante.", tags: ["fresco", "frutado", "jovem", "leve"] },
                    { label: "Sensual e marcante 💕", desc: "Quero uma fragrância com presença.", tags: ["sensual", "quente", "sofisticado", "festa"] }
                ]
            },
            {
                title: "Qual família olfativa te chama mais?",
                subtitle: "Pense no cheiro que você mais ama sentir na pele.",
                options: [
                    { label: "Baunilha, caramelo e chocolate 🍫", desc: "Doces cremosos e viciantes.", tags: ["baunilha", "caramelo", "doce", "gourmand", "cremoso"] },
                    { label: "Coco, âmbar e notas solares 🥥", desc: "Verão, areia e pele iluminada.", tags: ["coco", "ambar", "solar", "tropical", "praia"] },
                    { label: "Frutas tropicais e cítricas 🍍", desc: "Energia, juventude e frescor.", tags: ["frutado", "tropical", "energetico", "jovem", "fresco"] },
                    { label: "Flores delicadas 🌺", desc: "Feminilidade leve com charme.", tags: ["floral", "delicado", "leve"] }
                ]
            },
            {
                title: "Para qual ocasião você usaria mais?",
                subtitle: "Isso ajuda a definir intensidade e personalidade.",
                options: [
                    { label: "Dia a dia aconchegante 😊", desc: "Algo gostoso, fácil de amar.", tags: ["aconchegante", "delicado", "leve", "cremoso"] },
                    { label: "Praia, piscina ou férias 🏖️", desc: "Um perfume com cara de verão.", tags: ["praia", "verao", "solar", "tropical", "coco"] },
                    { label: "Rolê, festa ou encontro 🪇", desc: "Quero chamar atenção com leveza.", tags: ["sensual", "festa", "jovem", "energetico"] },
                    { label: "Pós-banho refrescante 🛀", desc: "Quero me sentir limpa e renovada.", tags: ["fresco", "aquatico", "leve", "frutado"] }
                ]
            },
            {
                title: "Você prefere um doce mais...",
                subtitle: "Mesmo quem ama doce pode preferir estilos diferentes.",
                options: [
                    { label: "Leitoso e macio 🐮", desc: "Como leite, nata e musk.", tags: ["cremoso", "aconchegante", "delicado"] },
                    { label: "Caramelizado e intenso 🍬", desc: "Baunilha, caramelo e chocolate branco.", tags: ["caramelo", "baunilha", "gourmand", "quente"] },
                    { label: "Com castanhas e pistache 🌰", desc: "Amêndoas, macadâmia e toque sofisticado.", tags: ["pistache", "sofisticado", "gourmand", "quente"] },
                    { label: "Quase nada doce 🍋", desc: "Prefiro frescor, frutas e flores.", tags: ["fresco", "frutado", "floral", "leve"] }
                ]
            },
            {
                title: "Qual imagem combina mais com você?",
                subtitle: "Escolha o cenário que mais parece o seu mood.",
                options: [
                    { label: "Sobremesa cremosa 🍰", desc: "Doce, confortável e irresistível.", tags: ["doce", "cremoso", "gourmand"] },
                    { label: "Pele bronzeada ao sol 🌞", desc: "Quente, solar e luminosa.", tags: ["solar", "quente", "praia"] },
                    { label: "Drink tropical na praia 🍹", desc: "Frutas, energia e diversão.", tags: ["tropical", "frutado", "energetico", "festa"] },
                    { label: "Banho de mar 🏄‍♀️", desc: "Frescor, brisa e leveza.", tags: ["aquatico", "fresco", "leve"] }
                ]
            },
            {
                title: "Como você quer que te percebam?",
                subtitle: "A fragrância também comunica uma intenção.",
                options: [
                    { label: "Doce e acolhedora 🤗", desc: "Um perfume que aproxima.", tags: ["doce", "aconchegante", "delicado"] },
                    { label: "Solar e espontânea 😆", desc: "Vibe verão sem esforço.", tags: ["solar", "verao", "livre", "tropical"] },
                    { label: "Jovem e cheia de energia 😁", desc: "Alegre, frutada e divertida.", tags: ["jovem", "frutado", "energetico"] },
                    { label: "Sensual e confiante 😘", desc: "Feminina, marcante e envolvente.", tags: ["sensual", "sofisticado", "quente"] }
                ]
            }
        ];
    }

    init() {

        const productsScript = this.querySelector("[data-products-json]");
        this.products = this.fallbackProducts;

        try {
            const customProducts = JSON.parse(productsScript.textContent || "[]")
                .filter((product) => { return product && product.id && product.name; })
                .map((product) => {
                    product.tags = Array.isArray(product.tags)
                        ? product.tags.map((tag) => { return String(tag).trim(); }).filter(Boolean)
                        : [];
                    return product;
                });

            if (customProducts.length >= 3) this.products = customProducts;
        } catch (error) {
            this.products = this.fallbackProducts;
        }

        this.current = 0;
        this.answers = [];

        this.nextBtn.addEventListener("click", () => {
            if (this.answers[this.current] === undefined) return;

            if (this.current === this.questions.length - 1) {
                this.showResults();
            } else {
                this.current += 1;
                this.renderQuestion();
            }
        });

        this.prevBtn.addEventListener("click", () => {
            if (this.current === 0) return;
            this.current -= 1;
            this.renderQuestion();
        });

        this.restartBtn.addEventListener("click", () => {
            this.current = 0;
            this.answers.length = 0;
            this.resultArea.classList.add("yb-hidden");
            this.quizArea.classList.remove("yb-hidden");
            this.renderQuestion();
            this.quizArea.scrollIntoView({ behavior: "smooth", block: "start" });
        });

        this.renderQuestion();
    }


    renderQuestion() {
        const question = this.questions[this.current];
        const progress = Math.round((this.current / this.questions.length) * 100);

        this.stepLabel.textContent = "Pergunta " + (this.current + 1);
        this.progressText.textContent = "Pergunta " + (this.current + 1) + " de " + this.questions.length;
        this.progressPercent.textContent = progress + "%";
        this.progressBar.style.width = progress + "%";

        this.questionTitle.textContent = question.title;
        this.questionSubtitle.textContent = question.subtitle;
        this.optionsEl.innerHTML = "";

        question.options.forEach((option, index) => {
            const button = document.createElement("button");
            button.className = "yb-option" + (this.answers[this.current] === index ? " is-active" : "");
            button.type = "button";
            button.innerHTML = "<b>" + option.label + "</b><small>" + option.desc + "</small>";

            button.addEventListener("click", () => {
                this.answers[this.current] = index;
                this.nextBtn.disabled = false;
                this.renderQuestion();
            });

            this.optionsEl.appendChild(button);
        });

        this.prevBtn.disabled = this.current === 0;
        this.nextBtn.disabled = this.answers[this.current] === undefined;
        this.nextBtn.textContent = this.current === this.questions.length - 1 ? "Ver resultado" : "Próxima";
    }

    hasTag(product, tag) {
        return product.tags.indexOf(tag) !== -1;
    }

    calculateResults() {
        const score = {};
        this.products.forEach((product) => {
            score[product.id] = 0;
        });

        this.answers.forEach((answerIndex, questionIndex) => {
            const option = this.questions[questionIndex].options[answerIndex];
            if (!option) return;

            this.products.forEach((product) => {
                option.tags.forEach((tag) => {
                    if (this.hasTag(product, tag)) score[product.id] += 2;
                });
            });

            if (option.tags.indexOf("pistache") !== -1 && score["pistachio-paradise"] !== undefined) {
                score["pistachio-paradise"] += 5;
            }

            if (option.tags.indexOf("caramelo") !== -1) {
                if (score["caramel-glow"] !== undefined) score["caramel-glow"] += 4;
                if (score["milk-dream"] !== undefined) score["milk-dream"] += 2;
                if (score["vanilla-waves"] !== undefined) score["vanilla-waves"] += 2;
            }

            if (option.tags.indexOf("coco") !== -1) {
                if (score["coconut-skin"] !== undefined) score["coconut-skin"] += 4;
                if (score["summer-vibes"] !== undefined) score["summer-vibes"] += 3;
            }

            if (option.tags.indexOf("aquatico") !== -1 && score["mermaid-kiss"] !== undefined) {
                score["mermaid-kiss"] += 5;
            }

            if (option.tags.indexOf("energetico") !== -1) {
                if (score["sex-on-the-beach"] !== undefined) score["sex-on-the-beach"] += 3;
                if (score["goxxtosa"] !== undefined) score["goxxtosa"] += 3;
            }
        });

        return this.products
            .map((product) => {
                const copy = Object.assign({}, product);
                copy.score = score[product.id] || 0;
                return copy;
            })
            .sort((a, b) => {
                return b.score - a.score;
            })
            .slice(0, Number(this.dataset.resultsCount));
    }

    escapeHtml(value) {
        return String(value || "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    }

    renderVisual(product) {
        if (product.image) {
            const focalPoint = product.focalPoint
                ? `style="object-position: ${product.focalPoint};"`
                : ''
            return '<img class="yb-product-image"' + focalPoint + 'src="' + this.escapeHtml(product.image) +'" alt="' + this.escapeHtml(product.name) + '" loading="lazy">';
        }

        return '<div class="yb-bottle" data-label="' + this.escapeHtml(product.label || product.name) + '"></div>';
    }

    showResults() {
        const matches = this.calculateResults();

        this.progressText.textContent = "Quiz completo";
        this.progressPercent.textContent = "100%";
        this.progressBar.style.width = "100%";

        this.resultGrid.innerHTML = matches.map((product, index) => {
            const percent = Math.max(78, Math.min(99, 99 - index * 5));
            const shopLink = product.url
                ? '<a class="button" href="' + this.escapeHtml(product.url) + '">' + this.dataset.buttonLabel + '</a>'
                : "";
            const productImage = product.url
                ? '<a href="' + this.escapeHtml(product.url) + '">' + this.renderVisual(product) + '</a>'
                : this.renderVisual(product);

            return '' +
                '<article class="product-card">' +
                    '<div class="yb-product-visual" style="--tone1:' + this.escapeHtml(product.tone1 || "#f3d4a7") + ';--tone2:' + this.escapeHtml(product.tone2 || "#e0a25b") + ';--bottle1:' + this.escapeHtml(product.bottle1 || "#fff0cf") + ';--bottle2:' + this.escapeHtml(product.bottle2 || "#b67f45") + ';">' +
                        '<div class="product-card__badge-list"><span class="badge badge--custom">' + (index === 0 ? "Top match" : "Match") + '</span></div>' +
                        productImage +
                    '</div>' +
                    '<div class="yb-product-info">' +
                        '<h3><strong>' + this.escapeHtml(product.name) + '</strong></h3>' +
                        '<p>' + this.escapeHtml(product.profile) + '</p>' +
                        '<span class="yb-match"><strong>' + percent + '% match</strong></span>' +
                        shopLink +
                    '</div>' +
                '</article>';
        }).join("");

        this.quizArea.classList.add("yb-hidden");
        this.resultArea.classList.remove("yb-hidden");
        this.resultArea.scrollIntoView({ behavior: "smooth", block: "start" });
    }
}


if (!customElements.get('quiz-component')) {
    customElements.define('quiz-component', Quiz);
}